import React, { Component } from "react";
import { Link } from "react-router-dom";
import Configuration from "../../../config/configuration";
import Axios from "axios";

class Makes extends Component {
  constructor(props) {
    super();
    this.apiURL = new Configuration().apiBaseUrl;
    this.state = {
      bodyTypes: [],
      makes: [],
    };
  }

  componentDidMount() {
    this.getMakes();
  }
  getMakes() {
    Axios.get(`${this.apiURL}makes?category=car`).then((res) => {
      console.log(res.data);
      this.setState({
        makes: res.data,
      });
    });
  }

  render() {
    return (
      <div className="makes">
        <div className="row">
          {this.state.makes.slice(0, 6).map((type, i) => {
            return (
              <div className="col-lg-2 col-md-3 col-6 mb-0">
                <Link to={`/used-cars/search/-/mk_${type.name.toLowerCase().replaceAll(" ", "-")}_${type.id}`}>
                  <div className="card card-makers">
                    <img loading="lazy" src={type.logoUrl} alt={type.name} />
                  </div>
                  <p className="mt-2 text-dark">
                    {type.name} ({type.adsCount})
                  </p>
                </Link>
              </div>
            );
          })}
        </div>
        {/* <div className="d-flex justify-content-end">
                    <Link to={'/makes'}><u>View more..</u></Link>
                </div> */}
      </div>
    );
  }
}

export default Makes;
